import { createFileRoute } from '@tanstack/react-router';
import { organizationQueries } from '@/features/organizations/queries';
import { billingAddressQueries } from '@/features/billing-addresses/queries';
import { OrganizationDetailPage } from '@/features/organizations/pages/OrganizationDetailPage';
import { OrgDetailPageSkeleton } from '@/common/components/loading-skeleton/OrgDetailPageSkeleton';

export const Route = createFileRoute('/_authenticated/organizations/$organizationId')({
  parseParams: ({ organizationId }) => ({ organizationId: Number(organizationId) }),
  stringifyParams: ({ organizationId }) => ({ organizationId: String(organizationId) }),
  component: RouteComponent,
  pendingComponent: OrgDetailPageSkeleton,
  loader: async ({ context, params }) => {
    const [org] = await Promise.all([
      context.queryClient.ensureQueryData(organizationQueries.detail(params.organizationId)),
      context.queryClient.ensureQueryData(billingAddressQueries.list()),
    ]);
    return { breadcrumb: org.name };
  },
});

function RouteComponent() {
  const { organizationId } = Route.useParams();
  return <OrganizationDetailPage organizationId={organizationId} />;
}
